import React from "react";

// --- CSS --- //
import "../styles/dropdown.css";

const Dropdown = ({ items }) => {
    return (
        <div className="dropdown-menu">
            <ul>
                {items.map((item, index) => (
                    <li 
                        key={index} 
                        onClick={item.onClick || (() => window.location.href = item.link)}
                        className={item.className}
                        style={item.style}
                    >
                        {item.icon}
                        <span style={{ marginLeft: "10px" }}>{item.title}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Dropdown;